const dispatchAction = (dispatch, action, params) => dispatch(action(params));

export default dispatchAction;
